import { useParams } from 'react-router-dom'

import { AddToClassModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/AddToClassModal'

const AssignParticipant = () => {
  const { accessId } = useParams()

  return <AddToClassModal accessIds={[String(accessId)]} />
}

export default AssignParticipant
